
import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  className?: string;
}

export const PageHeader = ({ title, subtitle, children, className = "" }: PageHeaderProps) => {
  return (
    <div className={`text-center space-y-6 mb-12 ${className}`}>
      <h1 className="text-5xl sm:text-6xl font-bold text-black font-inter tracking-inter-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="text-xl text-gray-600 max-w-3xl mx-auto font-inter leading-relaxed">
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
};
